import type { CustomNode, CustomEdge } from '@src/components/custom-nodes/types';
import { Position } from 'reactflow';

export const recalculateHandlePositions = (nodes: CustomNode[], edges: CustomEdge[]) => {
  const nodesWithCloseIf = nodes.filter((node) => node.type === 'IfCloseNode');

  nodesWithCloseIf.forEach((node) => {
    const edgesWithCurrentNodeAsTarget = edges.filter((edge) => edge.target === node.id);
    edgesWithCurrentNodeAsTarget.forEach((edge) => {
      const sourceNode = nodes.find((node) => node.id === edge.source);

      if (!sourceNode) return;

      if (sourceNode?.position.x < node.position.x) {
        edge.targetHandle = Position.Left;
      } else if (sourceNode?.position.x > node.position.x) {
        edge.targetHandle = Position.Right;
      } else {
        edge.targetHandle = Position.Top;
      }
    });
  });
};
